import React, { useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import i18next from 'i18next';

const ChartLine = (props) => {

	const { 
		inputParam_ChartData = null,
		inputParam_Width = 300,
		inputParam_ChartConfig = null
	} = props;

  	const [options, setOptions] = useState({
		chart: {
			type: 'line',
			dropShadow: {
			  	enabled: true,
			  	color: '#000',
			  	top: 18,
			  	left: 7,
			  	blur: 10,
			  	opacity: 0.2
			},
			toolbar: {
			  	show: true
			}
		},

		stroke: {
			curve: 'smooth'
		},
		xaxis: {
			categories: inputParam_ChartData.flatMap(({ l_vals }) => l_vals.map(({ periodId }) => periodId))
		},
		yaxis: {
			labels: {
				formatter: (val) => (Number.isFinite(Number(val)) ? `${Number(val).toFixed(0)}%` : val),
			},
			tickAmount: 5,
			min: inputParam_ChartConfig ? inputParam_ChartConfig.logroMinimo : undefined,
    		max: inputParam_ChartConfig ? inputParam_ChartConfig.logroMaximo : undefined
		},
		grid: {
			borderColor: '#e7e7e7',
			row: {
			  	colors: ['#f3f3f3', 'transparent'],
			  	opacity: 0.5
			},
		},
		  markers: {
			size: 1
		},
		legend: {
			position: 'bottom',
			showForSingleSeries: true,
		},
		colors: ['#008FFB','#00E396','#FEB019','#FF4560','#775DD0','#3F51B5','#F48024','#7E36AF','#1ABC9C','#D35400'] 
	});

	const [series, setSeries] = useState(inputParam_ChartData.map(item => ({
		name: item.name,
		data: item.l_vals.map(({ scopeValue }) => scopeValue)
	})));

 	return (
			<Col>
				<Row>
					<Col>
						<ReactApexChart
							options={options}
							series={series}
							type="line"
							height={inputParam_Width}
						/>
					</Col>
				</Row>
			</Col>
  	);
};

ChartLine.propTypes = {
	inputParam_ChartData: PropTypes.array.isRequired,
};

export default ChartLine;